var mainslide = document.querySelector(".index-mainslide");
if (mainslide) {
  new Splide(mainslide, {
    type: "slide",            // Enables fade transition
    rewind: true,            // Go back to the first slide after last
    perPage: 1,
    autoplay: true,
    interval: 3000,          // Delay between slides
    speed: 1500,
    arrows: false,             // Duration of fade transition (ms)
    pagination: true,
    drag: false,
  }).mount();
}

var colecSlider = document.querySelector(".colec-list-slider");
if (colecSlider) {
  const splide = new Splide(colecSlider, {
    type: 'slide',
    perPage: 4,
    perMove: 1,
    gap: '1.5rem',
    pagination: false,
    arrows: false, // explicitly state arrows
    breakpoints: {
      480: {
        perPage: 2,
        gap: '1rem'
      },
      640: {
        perPage: 2,
        gap: '1rem'
      },
      768: {
        perPage: 3,
        gap: '1rem',
        arrows: true,
      },
      1024: {
        perPage: 4,
        gap: '1rem'
      },
    },
  });
  // Add has-arrows class after Splide is mounted
  splide.on('mounted', () => {
    if (colecSlider.querySelector('.splide__arrows')) {
      colecSlider.classList.add('has-arrows');
    }
  });
  // Mount Splide
  splide.mount();
}


var testimonialSlider = document.querySelector(".cltstmnl-slide");

if (testimonialSlider) {
  const splide = new Splide(testimonialSlider, {
      
    type: 'loop',
    perPage: 2.5,
    perMove: 1,
    gap: '2rem',
    padding: '2rem',
    pagination: false,
    arrows: true,
    autoplay: false,
    speed: 500,
    interval: 1500,
    padding: { left: 250 },
    autoScroll: false, // ✅ disables auto scroll
    breakpoints: {
      767: {
   
        perPage: 1,
        gap: '1rem',
      },
      992: {
        perPage: 2,
        gap: '2rem',
        padding: { left: "10%", right: "10%" },
      },
       1199: {
        perPage: 2,
        padding: { left: "15%", right: "15%" },
      },
      1440: {
        perPage: 2.5,
        gap: '2rem',
      },
    },
  });

  splide.on('mounted', () => {
    if (testimonialSlider.querySelector('.splide__arrows')) {
      testimonialSlider.classList.add('has-arrows');
    }
  });

  splide.mount();
}

// FAQ accordion - open one at a time
document.addEventListener('DOMContentLoaded', function() {

  var faqQuestions = document.querySelectorAll('.faqpg-item');

  faqQuestions.forEach(function(question) {
    question.addEventListener('click', function() {
      var parentItem = question.closest('.faqpg-item');

      // Close all other items
      document.querySelectorAll('.faqpg-item.active').forEach(function(item) {
        if (item !== parentItem) {
          item.classList.remove('active');
        }
      });

      // Toggle clicked item
      parentItem.classList.toggle('active');
    });
  });

});

function initRelProductSlider(container) {
  const slider = container.querySelector(".relslide");

  if (slider && !slider.classList.contains("splide-initialized")) {
    slider.classList.add("splide-initialized");

    const splide = new Splide(slider, {
      type: "slide",
      perPage: 3,
      perMove: 1,
      gap: "2rem",
      pagination: false,
      arrows: true,
      breakpoints: {
        992: {
          perPage: 2,
          gap: "1.5rem"
        },
        640: {
          perPage: 1,
          gap: "1rem"
        }
      }
    });

    // Move arrows to bottom
  splide.on("mounted", () => {
  const arrows = slider.querySelector(".splide__arrows");
  const headingWrap = slider.querySelector(".hdng-btn-wrap");

  if (arrows && headingWrap) {
    headingWrap.appendChild(arrows);
  }
});


    splide.mount();
  }
}

// Watch for Shopify recommendations load
const recommendations = document.querySelector("product-recommendations");
if (recommendations) {
  const observer = new MutationObserver(() => {
    initRelProductSlider(recommendations);
  });
  observer.observe(recommendations, { childList: true, subtree: true });
}

// Run on normal page load
document.addEventListener("DOMContentLoaded", function () {
  initRelProductSlider(document);
});

document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".tab-button");
  const contents = document.querySelectorAll(".tab-content");

  buttons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const tabId = btn.getAttribute("data-tab");

      // Remove active states
      buttons.forEach((b) => b.classList.remove("active"));
      contents.forEach((c) => c.classList.remove("active"));

      // Activate selected tab
      btn.classList.add("active");
      document.getElementById(tabId).classList.add("active");
    });
  });
});
